export const playClawHomeUrl = import.meta.env.VITE_PLAY_CLAW_URL;
const AUTH_REDIRECT_QUERY_KEY = 'redirect_url';

if (!playClawHomeUrl) {
  throw new Error('Missing VITE_PLAY_CLAW_URL');
}

export const playClawOrigin = new URL(playClawHomeUrl).origin;

const parseCandidateUrl = (value: string | null): URL | null => {
  if (!value) {
    return null;
  }

  try {
    const candidateUrl = new URL(value);

    return candidateUrl;
  } catch {
    return null;
  }
};

const readRedirectUrlFromSearch = (): URL | null => {
  const searchParams = new URLSearchParams(window.location.search);
  const redirectUrl = searchParams.get(AUTH_REDIRECT_QUERY_KEY);
  const candidateUrl = parseCandidateUrl(redirectUrl);

  return candidateUrl;
};

const readRedirectUrlFromHash = (): URL | null => {
  const rawHash = window.location.hash;

  if (!rawHash) {
    return null;
  }

  const normalizedHash = rawHash.startsWith('#') ? rawHash.slice(1) : rawHash;
  const hashValue = normalizedHash.startsWith('/') ? normalizedHash : `/${normalizedHash}`;
  const hashUrl = new URL(hashValue, window.location.origin);
  const redirectUrl = hashUrl.searchParams.get(AUTH_REDIRECT_QUERY_KEY);
  const candidateUrl = parseCandidateUrl(redirectUrl);

  return candidateUrl;
};

const isAllowedRedirectUrl = (candidateUrl: URL): boolean => {
  const isAllowedOrigin = candidateUrl.origin === playClawOrigin;

  return isAllowedOrigin;
};

export const getPlayClawRedirectUrl = (): string => {
  const searchRedirectUrl = readRedirectUrlFromSearch();

  if (searchRedirectUrl && isAllowedRedirectUrl(searchRedirectUrl)) {
    return searchRedirectUrl.toString();
  }

  const hashRedirectUrl = readRedirectUrlFromHash();

  if (hashRedirectUrl && isAllowedRedirectUrl(hashRedirectUrl)) {
    return hashRedirectUrl.toString();
  }

  return playClawHomeUrl;
};

export const buildAuthPageUrl = (pathname: '/sign-in' | '/sign-up'): string => {
  const redirectUrl = getPlayClawRedirectUrl();
  const authPageUrl = new URL(pathname, window.location.origin);
  authPageUrl.searchParams.set(AUTH_REDIRECT_QUERY_KEY, redirectUrl);
  const resolvedPath = `${authPageUrl.pathname}${authPageUrl.search}`;

  return resolvedPath;
};
